<template>
  <div>
    <header-image
      :headerContents="headerContents"
      :headerBackground="'home'"
    />
    <rare-awards/>
  </div>
</template>

<script>

import HeaderHeroImage from '../../components/header/HeaderHeroImage';
import RareAwards from '../../components/carousels/awardsCarousel';


import Rare404HeaderContents from './components/Rare404HeaderContents';

export default {
  name: 'NotFound',
  components: {
    'header-image': HeaderHeroImage,
    'rare-404-header-contents': Rare404HeaderContents,
    'rare-awards': RareAwards,
  },
  data() {
    return {
      headerContents: 'rare-404-header-contents',
    };
  },
  mounted() {
  },
};
</script>


<style lang="scss" scoped>

@import "~@/css/global.scss";


</style>




// WEBPACK FOOTER //
// src/pages/errorNotFound/notFound.vue